<template>
  <div class="home">
    <div v-if="false" class="itemize" id="headerTab">
      <van-tabs v-model="params.secondCategory" @change="selectItem()">
        <van-tab
          :name="item.id"
          v-for="(item, index) in itemizeList"
          :key="index"
          :title="item.title"
        ></van-tab>
      </van-tabs>
    </div>
    <div v-if="false" class="search-pannel">
      <mt-search
        @keyup.enter.native="search"
        v-model="params.key"
        cancel-text="取消"
        placeholder="搜索"
      ></mt-search>
    </div>

    <div
      id="content"
      class="content-pannel"
      ref="wrapper"
      :style="{ height: wrapperHeight + 'px' }"
    >
      <div class="item" @click="goDetail(item)" v-for="(item, index) in list" :key="index">
        <div class="item-title-view">
          <div>{{item.title}}</div>
          <div>{{item.author ? item.author : ''}} {{item.gmtCreate | date(2)}}</div>
        </div>
        <div>
          <img :src="item.coverImg" alt />
        </div>
      </div>
      <div class="no-list" v-if="list.length == 0">暂无文章！</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  data () {
    return {
      allLoaded: false,
      cityMore: false,
      wrapperHeight: 0,
      bottomStatus: '',
      mainContentDom: '',
      list: [],
      params: {
        tenant_id: '',
        page: 0,
        size: 15,
        key: '',
        status: 1,
        categories: ''
      },
      isAll: true,
      itemizeList: [],
      headerTabDom: ''
    }
  },
  components: {
  },
  mounted () {
    let _tenant_id = this.getUrlParam('tid')
    let _title = this.getUrlParam('tit')
    let _itemid = this.getUrlParam('seid')
    if (!_tenant_id) {
      // alert('未获取到关键ID！')
    }
    // 获取id
    // this.params.tenant_id = _tenant_id ? _tenant_id : '精选文章'
    document.title = _title
    // this.getItemizeList(this.params.tenant_id)
    // 如果有二级id
    if (_itemid) {
      this.isAll = false
      this.params.categories = _itemid
    }
    this.getList()
    this.$nextTick(() => {
      setTimeout(() => {
        this.mainContentDom = document.getElementById('content')
        if (this.mainContentDom) {
          this.mainContentDom.addEventListener('scroll', this.handleScroll)
        }
      }, 500)
    })
    this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top;
  },
  methods: {
    headerTabScroll (e) {

    },
    selectItem (id) {
      this.list = []
      this.isAll = false
      this.allLoaded = false
      this.params.page = 0
      this.params.secondCategory = this.params.secondCategory
      this.getList()
    },
    showAll () {
      this.list = []
      this.isAll = true
      this.allLoaded = false
      this.params.page = 0
      this.params.secondCategory = ""
      this.getList()
    },
    handleScroll (e) {
      if (e.target.scrollTop == ((e.target.scrollHeight - this.wrapperHeight) + 0.5)) {
        if (!this.allLoaded) {
          this.getList()
        }
      }
    },
    search () {
      this.list = []
      this.params.page = 0
      this.getList()
    },
    async getList () {
      this.params.page += 1
      let data = await this.axios.get('content-service/cnt_article_net/page', this.params)
      if (data.flag == 0) {
        this.list.push(...data.data.content)
        if (data.data.content.length < 15) {
          this.allLoaded = true
        }
      }
    },
    async getItemizeList (id) {
      this.itemizeList =[_all]
      return false
      let data = await this.axios.get('content-service/cnt_article_net/level_second/list', { tenant_id: id })
      if (data.flag == 0) {
        let _all = {
          id: "",
          title: "全部分类",
        }
        this.itemizeList =[_all]
        // this.itemizeList =[_all, ...data.data]
      }
    },
    goDetail (item) {
      // 说明是外链
      if (item.type == 1 && item.linkUrl) {
        window.open(item.linkUrl)
      } else {
        this.$router.push('/detail/' + item.id)
      }
    },
    getUrlParam (key) {
      // 获取参数
      var url = window.location.search;
      // 正则筛选地址栏
      var reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
      // 匹配目标参数
      var result = url.substr(1).match(reg);
      //返回参数值
      return result ? decodeURIComponent(result[2]) : null;
    }
  }
}
</script>

<style lang="less">
.home {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .no-list {
    font-size: 0.4rem /* 15/37.5 */;
    margin-top: 0.4rem /* 15/37.5 */;
  }
  .itemize {
    width: 100vw;
    height: 1.16rem /* 43.5/37.5 */;
  }
  .mint-search {
    height: 100% !important;
  }
  .search-pannel {
    margin-top: 0.266667rem /* 10/37.5 */;
    padding: 0px 0.4rem; /* 15/37.5 */
  }
  .search {
    width: 100%;
    height: 3.306667rem /* 124/37.5 */;
  }
  .content-pannel {
    width: 100%;
    height:  100%;
    overflow: scroll;
    padding: 0px 0.4rem; /* 15/37.5 */
  }

  .item {
    width: 100%;
    height: 2.866667rem /* 107.5/37.5 */;
    border-bottom: 0.026667rem /* 1/37.5 */ solid #eeeeee;
    display: flex;
    align-items: center;
    padding: 0px 0.066667rem /* 2.5/37.5 */;
  }

  .item > div:last-child,
  .item > div:last-child > img {
    width: 2.533333rem /* 95/37.5 */;
    height: 1.76rem /* 66/37.5 */;
    border-radius: 0.066667rem /* 2.5/37.5 */;
  }

  .item > div:first-child {
    flex: 1;
    height: 1.76rem /* 66/37.5 */;
    padding-right: 0.186667rem /* 7/37.5 */;
  }

  .item-title-view {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .item-title-view > div:first-child {
    font-size: 0.4rem /* 15/37.5 */;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .item-title-view > div:last-child {
    font-size: 0.32rem /* 12/37.5 */;
    font-family: PingFangSC-Light;
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
  }
}
</style>
